import './MapCMMultipleGeometriesSelected.less';
import { Layer, Source } from 'react-map-gl';
import { Feature } from '../../../models/Geoserver';
import { useAppSelector } from '../../../store/hooks/hooks';
import { useMemo } from 'react';


function MapCMMultipleGeometriesSelected() {

  const features: Feature[] = useAppSelector(state => state.mapLayers.preSelectedFeatures);
  const polygons = useMemo(() => features.filter(f => ['MultiPolygon', 'Polygon'].includes(f.geometry.type)), [features]);
  const lines = useMemo(() => features.filter(f => ['MultiLineString', 'LineString'].includes(f.geometry.type)), [features]);
  const points = useMemo(() => features.filter(f => ['MultiPoint', 'Point'].includes(f.geometry.type)), [features]);

  return (
    <div>
      <Source id={'MapCMMultipleGeometrySource-poligons'}
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: polygons as any,
              }}
      >

        <Layer beforeId={'order-polygon'} id={'cm_multiple_geometry-polygons'} type={'fill'} paint={{
          'fill-color': '#595959',
          'fill-opacity': 1,
        }}
        />
        <Layer beforeId={'order-polygon'} id={'cm_multiple_geometry_line-polygons'} type={'line'} paint={{
          'line-color': '#48C2C4',
          'line-width': 5,
        }}
        />
      </Source>
      <Source id={'MapCMMultipleGeometrySource-lines'}
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: lines as any,
              }}
      >

        <Layer beforeId={'order-polygon'} id={'cm_multiple_geometry-lines'} type={'line'} paint={{
          'line-color': '#48C2C4',
          'line-width': 5,
        }}
        />
      </Source>
      <Source id={'MapCMMultipleGeometrySource-points'}
              type='geojson'
              data={{
                type: 'FeatureCollection',
                features: points as any,
              }}
      >

        <Layer beforeId={'order-polygon'} id={'cm_multiple_geometry-points'} type={'circle'} paint={{
          'circle-color': '#48C2C4',
          'circle-stroke-color': 'white',
          'circle-stroke-width': 2,
          'circle-radius': 6,
        }}
        />
      </Source>
    </div>
  );
}

export default MapCMMultipleGeometriesSelected;
